/**
 *
 * Asynchronously loads the component for Campuses Page
 *
 */

import { lazyLoad } from 'utils/loadable';

export const CampusesPage = lazyLoad(
  () => import('./index'),
  module => module.CampusesPage,
);
